import { useSearchParams, useRouter } from "next/navigation";

import { useStore, observer } from "../../../../service/mobx";
import MenuItem from "../../Item";

export default observer(function SearchMenu({ param, filter, items }) {
  const { analytics, bottomSheet, search, menu } = useStore();
  const value = useSearchParams().get(param);
  const router = useRouter();

  return items.map(([option, label]) => (
    <MenuItem
      key={option}
      selected={option === value}
      label={label}
      onClick={() => {
        if (bottomSheet.open) {
          bottomSheet.set.open(false);
        }
        search.updateUrlParams(router, {
          [param]: option === value ? [] : [option]
        });

        menu.close();
        analytics.track.event("Search Filter", {
          entity: { type: filter, value: option === value ? false : option }
        });
      }}
    />
  ));
});
